import React, { Component } from 'react';
import { ChevronDown } from 'react-feather';
import { IHeaderTextContext } from '@components-shared/table/types';
import { getColumnHeaderText } from '@components-shared/table/utils/tableHeaderUtils';
import cn from 'classnames';
import { ColumnValueType, DetailsTableDataCommonType, DetailsTableDataTypeWithKey, IDetailsTableColumn } from './types';

interface IDetailsTableRowProps<T, K> {
  col: IDetailsTableColumn<T, K>;
  data: DetailsTableDataCommonType<T>;
  headerTextContext: IHeaderTextContext;
}

interface IDetailsTableRowState {
  collapsed: boolean;
}

export class DetailsTableRow<T, K> extends Component<IDetailsTableRowProps<T, K>, IDetailsTableRowState> {
  constructor(props: IDetailsTableRowProps<T, K>) {
    super(props);
    this.state = {
      collapsed: !!this.props.col.collapsedByDefault,
    };

    this.toggleCollapsed = this.toggleCollapsed.bind(this);
  }

  toggleCollapsed(): void {
    const { col } = this.props;

    if (col.collapsable) {
      this.setState({ collapsed: !this.state.collapsed });
    }
  }

  render(): JSX.Element {
    const { col, data, headerTextContext } = this.props;
    const { collapsed } = this.state;

    const collapsable = col && col.collapsable;
    const itemClass = collapsable && collapsed ? 'collapsed' : '';

    const customClassName = typeof col.className === 'function' ? col.className(data) : col.className;
    const columnTitle = getColumnHeaderText(headerTextContext, col);

    return (
      <div className={cn('summary-table__row', customClassName)}>
        <div className="summary-table__label" onClick={this.toggleCollapsed}>
          {columnTitle}:{collapsable && <ChevronDown className={`summary-table__label-icon ${itemClass}`} size={22} />}
        </div>
        <div className={`summary-table__value respect-line-breaks ${itemClass}`}>
          {col.render
            ? col.render(data, getRecordValue(data, col.key))
            : (getRecordValue<T, K>(data, col.key) as never)}
        </div>
      </div>
    );
  }
}

export const getRecordValue = <T, K>(data: DetailsTableDataCommonType<T>, key: string): ColumnValueType<K> => {
  const keys = key.split('.');

  const result = keys.reduce((xs, x) => {
    if (!xs) {
      return null;
    }

    return typeof xs === 'object' ? (xs as unknown as DetailsTableDataTypeWithKey<T>)[x] : xs;
  }, data);

  return result as ColumnValueType<K>;
};
